import React from 'react';
import { StyledTr } from '../../../../../common/StyledComponents';
import { InputFieldWithValidation } from '../../../../../common/InputFieldWithValidation';
import { onlyDigits } from '../../../../../common/normalizationCommons';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import {
    FORM_FIELD_ORDER_AS_DRIVE_CMD,
    FORM_FIELD_ORDER_AS_DRIVE_LINE,
    FORM_FIELDS_ORDER_ITEMS,
    FORM_LABEL_AS_DRIVE,
    FORM_ORDERS_SECTION,
} from '../../../../../../constants/formConstants';
import { requiredIfGroupStarted, requireIfAnyInGroupFilled, validOrderAsDriveCmdLength, validOrderAsDriveLineLength } from '../../../../../common/validationCommons';
import { get } from 'lodash';
import { FORM_FIELD_ORDER_AS_DRIVE_CMD_MAX_LENGTH, FORM_FIELD_ORDER_AS_DRIVE_LINE_MAX_LENGTH } from '../../../../../../constants/validationConstants';
import { forwardRef } from 'react';
import ValidFormattedMessage from '../../../../../common/ValidFormattedMessage';
import formMessages from '../../../../../../intl/sparePartsOrders/formMessages';

const OrderAsDriveRow = (props) => {
    const {
        userRights,
        readOnly,
        orders,
        order,
        changeFocus
    } = props;

    const forceValidate = orders.some(order => {
        return order[FORM_FIELD_ORDER_AS_DRIVE_CMD] ||
            order[FORM_FIELD_ORDER_AS_DRIVE_LINE];
    });

    return (
        <StyledTr className="border-bottom-secondary">
            <td className="font-weight-bold text-right vertical border-0">
                <ValidFormattedMessage message={FORM_LABEL_AS_DRIVE} intlMessages={formMessages} />
            </td>
            <td className="border-0" colSpan="8">
                <div className="row m-0">
                    <InputFieldWithValidation
                        field={`${order}.${FORM_FIELD_ORDER_AS_DRIVE_CMD}`}
                        maxLength={3}
                        normalize={onlyDigits}
                        validations={[validOrderAsDriveCmdLength]}
                        isDisabled={!userRights.canEditAsDrive || readOnly}
                        setRef={get(props, `myForwardedRef.${FORM_FIELD_ORDER_AS_DRIVE_CMD}`, undefined)}
                        isSmall
                        style={{ maxWidth: '45px', marginRight: '5px' }}
                        handleKeyUp={
                            (value) => changeFocus(value, FORM_FIELD_ORDER_AS_DRIVE_CMD_MAX_LENGTH, FORM_FIELD_ORDER_AS_DRIVE_LINE)
                        }
                    />
                    <InputFieldWithValidation
                        field={`${order}.${FORM_FIELD_ORDER_AS_DRIVE_LINE}`}
                        maxLength={5}
                        normalize={onlyDigits}
                        validations={!userRights.canEditAsDrive || readOnly ?  [] :[validOrderAsDriveLineLength]}
                        isDisabled={!userRights.canEditAsDrive || readOnly}
                        setRef={get(props, `myForwardedRef.${FORM_FIELD_ORDER_AS_DRIVE_LINE}`, undefined)}
                        isSmall
                        style={{ maxWidth: '65px' }}
                        handleKeyUp={
                            (value) => changeFocus(value, FORM_FIELD_ORDER_AS_DRIVE_LINE_MAX_LENGTH, null)
                        }
                    />
                </div>
            </td>
        </StyledTr>
    );
};

const mapStateToProps = (state, props) => ({
    orders: formValueSelector(props.form)(state, `${FORM_ORDERS_SECTION}.${FORM_FIELDS_ORDER_ITEMS}`),
}
);

const ConnectedOrderAsDriveRow = connect(
    mapStateToProps
)(OrderAsDriveRow);

export default forwardRef((props, ref) =>
    <ConnectedOrderAsDriveRow {...props} myForwardedRef={ref} />
);